<template>
<div id="news">

<!-- Breadcrumbs -->
    <section class="city-breadcrumb"></section>
        <div class="row breadcrumb-box">
            <div class="mr-3 ml-5">
                <p class="mbr-text city-footer-font-bread display-7 ">
                    <a class="city-footer-link-sub" href="/">Home</a> > {{ title }}</p>
            </div>
        </div> 

<!-- Content -->
        <div class="container">
            <div class="row">
                <div class="card container-fluid ml-3">
                    <img class="card-img-top mt-3" id="card-img-base64">
                    <div class="card-body mb-5">
                        <h1 class="city-title mt-2 ">{{ title }}</h1>
                        <div class="large-city-green-div "></div>
                        <div class="">

                        <div class="card">
                                  <div class="card-body">
                                  <img style="float: left; margin: 0px 15px 30px 0px;" src="../index_files/images/cbb.svg" alt="Clean Bays Blueprint Logo" width="100" />
                                  <a href="https://news.cctexas.com/news/releases-20201120">
                                    <h5 class="card-title city-sub">2020 Holiday Grease Roundup&nbsp;»</h5>
                                  </a>
                                    <p class="card-text city-p">Grease Containers and Used Cooking Oil Drop-off Location Available.</p>
                                      <small>November 20, 2020</small>
                                  </div>
                                </div>
                                <hr>

                                <div class="card">
                                  <div class="card-body">
                                  <img style="float: left; margin: 0px 15px 30px 0px;" src="../index_files/images/cbb.svg" alt="Clean Bays Blueprint Logo" width="100" />
                                  <a href="https://www.epa.gov/enforcement/city-corpus-christi-consent-decree">
                                    <h5 class="card-title city-sub">EPA: City of Corpus Christi Consent Decree&nbsp;»</h5>
                                  </a>
                                    <p class="card-text city-p">This is the consent decree for City of Corpus Christi Settlement.</p>
                                      <small>September 25, 2020</small>
                                  </div>
                                </div>
                                <hr>

                                <div class="card">
                                  <div class="card-body">
                                  <img style="float: left; margin: 0px 15px 30px 0px;" src="../index_files/images/cbb.svg" alt="Clean Bays Blueprint Logo" width="100" />
                                  <a href="https://www.epa.gov/newsreleases/city-corpus-christi-agrees-invest-water-infrastructure-improvements">
                                    <h5 class="card-title city-sub">City of Corpus Christi Agrees to Invest in Water Infrastructure Improvements&nbsp;»</h5>
                                  </a>
                                    <p class="card-text city-p">The City Will Eliminate Sanitary Sewer System Overflows and Illegal Discharges.</p>
                                      <small>September 25, 2020</small>
                                  </div>
                                </div>
                                <hr>


                   </div> <!-- Content Here -->
                </div> 
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
  name: 'news',
  data () {
    return {
        title: 'News',
        crumbLink:'',
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/News.vue